module.exports = {
        srcSet: "/_next/static/images/london-640.8b393b36.webp"+" 640w"+","+"/_next/static/images/london-700.55ee453d.webp"+" 700w",
        images: [{path: "/_next/static/images/london-640.8b393b36.webp",width: 640,height: 640},{path: "/_next/static/images/london-700.55ee453d.webp",width: 700,height: 700}],
        src: "/_next/static/images/london-700.55ee453d.webp",
        toString: function(){return "/_next/static/images/london-700.55ee453d.webp"},
        
        width: 700,
        height: 700
      }